import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FEATURE_FLAG_KEYS } from '../../../config/growthbook';

/** The unified UW agent, which covers the three line agents. */
export const UNIFIED_UW_AGENT_ID = 'underwriter';

/** The Cyber, Tech E&O and ML agents the unified agent replaces. */
export const LINE_UW_AGENT_IDS = [
  'cyber-underwriter',
  'tech-eo-underwriter',
  'ml-underwriter',
] as const;

// Module constants so the result keeps one identity across renders: it feeds
// `MooChatConfig.hiddenAgentIds`, which `useAgentsCatalog` reads in the effect
// that seeds the shell catalog.
const HIDE_UNIFIED_UW: readonly string[] = [UNIFIED_UW_AGENT_ID];
const HIDE_LINE_UW: readonly string[] = LINE_UW_AGENT_IDS;

/**
 * Agent ids the chat panel hides, by `unified_uw_agent`: off hides the unified
 * `underwriter`, on hides the three line agents it replaces.
 */
export function useHiddenAgentIds(): readonly string[] {
  const unifiedUwOn = useFeatureIsOn(FEATURE_FLAG_KEYS.UNIFIED_UW_AGENT);
  return unifiedUwOn ? HIDE_LINE_UW : HIDE_UNIFIED_UW;
}
